import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconColumns3Wide: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="columns-3-wide, layout, third"><path d="M7.58984 20H5.75C3.67893 20 2 18.3211 2 16.25V7.75C2 5.67893 3.67893 4 5.75 4H7.58984V20Z" fill="currentColor"/><path d="M14.9102 20H9.08984V4H14.9102V20Z" fill="currentColor"/><path d="M18.25 4C20.3211 4 22 5.67893 22 7.75V16.25C22 18.3211 20.3211 20 18.25 20H16.4102V4H18.25Z" fill="currentColor"/></CentralIconBase>;
};

export default IconColumns3Wide;
